import BaseConnection from './pagination/BaseConnection';
import Reference from './Reference';

export default class ReferenceConnection extends BaseConnection {
  constructor(data = {}) {
    super(ReferenceConnection, Reference, data);
  }
}
